import qs from 'qs'
import To from 'await-to-js'

const cloudInstance = axios.create()
const preloadInstance = axios.create()

const modelSetting = Wiz.globalSettings.globalConfig.modelSetting
cloudInstance.defaults.baseURL = `${modelSetting.cloudProtocol === 'wss' ? 'https' : 'http'}://${
  modelSetting.cloudServerPathVulkan
}`
preloadInstance.defaults.baseURL = modelSetting.preloadServer || ''
export default class PreloadService {
  // 获取引擎节点
  static async getEngineId(payload) {
    const [err, res] = await To(preloadInstance.post('/api/preload/distribute-node', payload))
    return [err, res]
  }
  // 强制终止引擎
  static async forceTerminate(payload) {
    const [err, res] = await To(cloudInstance.get(`/kill?${qs.stringify(payload)}`))
    return [err, res]
  }
}
